export enum Command {
    None,
    Open,
    Close,
}
